import { FIELDS } from './constants';

const financialCreditCardsFields = [
  {
    field: 'commands',
    title: 'Actions',
    cell: 'commands',
    locked: true,
    hidden: false,
    width: 100,
  },
  {
    field: FIELDS.CARD_TYPE,
    title: 'Type',
    width: 150,
  },
  {
    field: FIELDS.ACCOUNT_LAST_4,
    title: 'Last 4',
    width: 150,
  },
  {
    field: 'expiry',
    title: 'Expiry',
    cell: 'Expiry',
    width: 150,
  },
]

export default financialCreditCardsFields;
